import { FunctionComponent, ReactNode } from "react";
import TextFieldAtom from "../../../../src/atoms/textfield";
import styles from "./Textarea.module.css";

export type TextAreaType = {
  id?: string;
  name?: string;
  className?: string;
  label?: string;
  showCharacterCounter?: boolean;
  input?: string;
  message?: string;
  placeholder?: string;

  /** Variant props */
  indicator?: "neutral" | "fail" | "success";
  state?: "default" | "disabled";
  type?: "outline" | "fill";
  variant?: "labelled" | "labelless";

  /** Custom props */
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  isRequired?: boolean;
  optionalText?: string;
  maxLength?: number;
  inputType?: "text" | "password" | "number" | "email" | "tel" | "url";
  value?: string | number;
  messages?: {
    text: string;
    type: "neutral" | "fail" | "success";
    icon?: ReactNode;
  }[];
  onChange?: (value: string | number) => void;
};

export const TextArea: FunctionComponent<TextAreaType> = (props) => {
  return (
    <TextFieldAtom
      {...props}
      inputElement="textarea"
      className={styles.root}
      maxLength={props.maxLength || 300}
    />
  );
};

TextArea.displayName = "TextArea";

export default TextArea;
